const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: 'Registed Date', sortable: false },
    { key: 'count', label: 'Using Site Count', sortable: false },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'policy', label: 'Max Page', sortable: false },
    { key: 'updated_at', label: 'Last Modify', sortable: false },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: '등록일', sortable: false },
    { key: 'count', label: '사용중인 사이트', sortable: false },
    { key: 'description', label: '설명', sortable: false },
    { key: 'policy', label: '최대 페이지', sortable: false },
    { key: 'updated_at', label: '최근 수정일', sortable: false },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: '登録日', sortable: false },
    { key: 'count', label: 'サイトカウントの使用', sortable: false },
    { key: 'description', label: '説明', sortable: false },
    { key: 'policy', label: '最大ページ数', sortable: false },
    { key: 'updated_at', label: '最終更新日', sortable: false },
  ]
}

const fields = { i18n_fields }

export default fields